import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { OptionType, SCTestReportResultOptions } from "../../../../../utils"
import { Calendar } from "../../../../../ui/molecules/calendar"
import Input from "../../../../../ui/molecules/input"
import { SingleCheckbox } from "../../../../../ui/molecules/SingleCheckbox"
import { setSCUpdateSamplingDate, setSCUpdateSamplingTime, setSCUpdateSamplingCompleted, setSCUpdatePlannedSampling, setSCUpdateMaterialSampled, setSCUpdateCollectionUnit, setSCUpdateLotNumber, setSCUpdateLaboratoryId, setSCUpdateCloratiPerclorati, setSCUpdateClormequatMepiquat, setSCUpdateFosetylAl, setSCUpdateGlifosate, setSCUpdateMultiresiduale, setSCUpdateOgm, setSCUpdateOtherDetail, setSCUpdateOther, setSCUpdateTestReportNumber, setSCUpdateTestReportDate, setSCUpdateEntryProtocolId, setSCUpdateTestReportResult, setSCUpdateEvaluationDate, setSCUpdatePrinciplesFound, setSCUpdateNote, SampleCollectionUpdate, resetGetAllLaboratoryStatus, GetAllLaboratory } from "./slice"
import { SelectCustom } from "../../../../../ui/molecules/select"
import { ProtocolSearch } from "../../../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../../../ui/molecules/textArea"
import Button from "../../../../../ui/molecules/button"
import { GetAllCodexSamples, resetGetAllCodexSamplesStatus } from "../../../../gestionePrelievi/slice"
import { CodexSampleChangeStatusEnum } from "../../../../gestionePrelievi/dataService/dto"
import { format } from "date-fns"

interface Props {
    close: () => void
}

export function IVGestionePrelieviEditPopup(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const sampleCollectionState = useAppSelector(state => state.sampleCollection)
    const codexSampleState = useAppSelector(state => state.codexSample)
    const userState = useAppSelector(state => state.users)
    const [envelopes, setEnvelopes] = useState<OptionType[]>([])
    const [laboratories, setLaboratories] = useState<OptionType[]>([])
    const [plannedSamplingFlag, setPlannedSamplingFlag] = useState<boolean>(false)
    const [completedSamplingFlag, setCompletedSamplingFlag] = useState<boolean>(false)
    const [multiresFlag, setMultiresFlag] = useState<boolean>(false)
    const [fosetyFlag, setFosetyFlagFlag] = useState<boolean>(false)
    const [ingegnerGiacomazzi, setIngegnerGiacomazzi] = useState<boolean>(false)
    const [ogmFlag, setOgmFlag] = useState<boolean>(false)
    const [cloratiFlag, setCloratiFlag] = useState<boolean>(false)
    const [clormequatFlag, setClormequatFlag] = useState<boolean>(false)
    const [otherFlag, setOtherFlag] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllCodexSamples({
            itemsPerPage: 0,
            page: 0,
            status: CodexSampleChangeStatusEnum.IN_GIACENZA
        }))
        dispatch(GetAllLaboratory({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        const req = sampleCollectionState.sampleCollectionUpdateRequest
        setPlannedSamplingFlag(req.plannedSampling !== undefined ? req.plannedSampling : false)
        setCompletedSamplingFlag(req.samplingCompleted !== undefined ? req.samplingCompleted : false)
        setMultiresFlag(req.multiresiduale !== undefined ? req.multiresiduale : false)
        setFosetyFlagFlag(req.fosetylAl !== undefined ? req.fosetylAl : false)
        setIngegnerGiacomazzi(req.glifosate !== undefined ? req.glifosate : false)
        setOgmFlag(req.ogm !== undefined ? req.ogm : false)
        setCloratiFlag(req.cloratiPerclorati !== undefined ? req.cloratiPerclorati : false)
        setClormequatFlag(req.clormequatMepiquat !== undefined ? req.clormequatMepiquat : false)
        setOtherFlag(req.other !== undefined ? req.other : false)
    }, [sampleCollectionState.sampleCollectionUpdateRequest])

    useEffect(() => {
        if (codexSampleState.getAllCodexSamplesStatus === 'successfully' &&
            codexSampleState.getAllCodexSampleResponse !== undefined
        ) {
            dispatch(resetGetAllCodexSamplesStatus())
            const data = codexSampleState.getAllCodexSampleResponse.data.map(cs => {
                return {
                    value: cs.id,
                    label: `${cs.envelopNumber}`
                } as OptionType
            })
            setEnvelopes(data)
        }
    }, [codexSampleState.getAllCodexSamplesStatus])

    useEffect(() => {
        if (sampleCollectionState.getAllLaboratoryStatus === 'successfully' &&
            sampleCollectionState.getAllLaboratoryResponse !== undefined
        ) {
            dispatch(resetGetAllLaboratoryStatus())
            const data = sampleCollectionState.getAllLaboratoryResponse.data.map(lab => {
                return {
                    value: lab.id,
                    label: `${lab.name} - ${lab.accreditationNumber}`
                } as OptionType
            })
            setLaboratories(data)
        }
    }, [sampleCollectionState.getAllLaboratoryStatus])

    useEffect(() => {
        if (sampleCollectionState.sampleCollectionUpdateStatus === 'successfully') {
            props.close()
        }
    }, [sampleCollectionState.sampleCollectionUpdateStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-subtitle text-left">
                        Codice di Identificazione del Verbale di Campionamento
                    </div>
                    <div className="assignment-text-bold text-left">
                        {sampleCollectionState.sampleCollectionIdentifier}
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Prelievo
                        </div>
                        <Calendar
                            selected={sampleCollectionState.sampleCollectionUpdateRequest.samplingDate}
                            onChange={(date) => dispatch(setSCUpdateSamplingDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCUpdateSamplingDate(date))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Orario Prelievo
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCUpdateSamplingTime(text))}
                            value={sampleCollectionState.sampleCollectionUpdateRequest.samplingTime}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Prelievo Previsto
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={plannedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdatePlannedSampling(value))
                                setPlannedSamplingFlag(value)
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Prelievo Effettuato
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={completedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateSamplingCompleted(value))
                                setCompletedSamplingFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Materiale Prelevato
                        </div>
                        <Input
                            value={sampleCollectionState.sampleCollectionUpdateRequest.materialSampled}
                            onChangeText={(text) => dispatch(setSCUpdateMaterialSampled(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Unità di Raccolta
                        </div>
                        <Input
                            value={sampleCollectionState.sampleCollectionUpdateRequest.collectionUnit}
                            onChangeText={(text) => dispatch(setSCUpdateCollectionUnit(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Lotto N.
                        </div>
                        <Input
                            value={sampleCollectionState.sampleCollectionUpdateRequest.lotNumber}
                            onChangeText={(text) => dispatch(setSCUpdateLotNumber(text))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <SelectCustom
                        placeholder="Seleziona laboratorio..."
                        options={laboratories}
                        value={sampleCollectionState.sampleCollectionUpdateRequest.laboratoryId}
                        onChange={(value) => dispatch(setSCUpdateLaboratoryId(value))}
                    />
                </div>

                <div className="pb-5 assignment-subtitle text-left">
                    Tipo di analisi
                </div>

                <div className="pb-2" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Multiresiduale
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={multiresFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateMultiresiduale(value))
                                setMultiresFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Fosetyl-AL
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={fosetyFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateFosetylAl(value))
                                setFosetyFlagFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Glifosate
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={ingegnerGiacomazzi}
                            setChecked={(value) => {
                                dispatch(setSCUpdateGlifosate(value))
                                setIngegnerGiacomazzi(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            OGM
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={ogmFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateOgm(value))
                                setOgmFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Clorati e Perclorati
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={cloratiFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateCloratiPerclorati(value))
                                setCloratiFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Clormequat e Mepiquat
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={clormequatFlag}
                            setChecked={(value) => {
                                dispatch(setSCUpdateClormequatMepiquat(value))
                                setClormequatFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Altro
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={otherFlag}
                        setChecked={(value) => {
                            dispatch(setSCUpdateOther(value))
                            setOtherFlag(value)
                            if(!value && sampleCollectionState.sampleCollectionUpdateRequest.otherDetail)
                                dispatch(setSCUpdateOtherDetail(''))
                        }}
                    />
                    <div style={{ flex: '1' }}>
                        <Input
                            value={sampleCollectionState.sampleCollectionUpdateRequest.otherDetail}
                            placeholder="Specifica altro..."
                            disabled={!otherFlag}
                            onChangeText={(text) => dispatch(setSCUpdateOtherDetail(text))}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Numero Rapporto di Prova
                        </div>
                        <Input
                            value={sampleCollectionState.sampleCollectionUpdateRequest.testReportNumber}
                            onChangeText={(text) => dispatch(setSCUpdateTestReportNumber(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Rapporto di Prova
                        </div>
                        <Calendar
                            selected={sampleCollectionState.sampleCollectionUpdateRequest.testReportDate}
                            onChange={(date) => dispatch(setSCUpdateTestReportDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCUpdateTestReportDate(date))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Protocollo
                    </div>
                    <ProtocolSearch
                        type="entry"
                        value={sampleCollectionState.sampleCollectionUpdateRequest.entryProtocolId}
                        onSelect={(value) => dispatch(setSCUpdateEntryProtocolId(value))}
                    />
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito Rapporto di Prova
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={SCTestReportResultOptions}
                            value={sampleCollectionState.sampleCollectionUpdateRequest.testReportResult}
                            onChange={(value) => dispatch(setSCUpdateTestReportResult(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Valutazione
                        </div>
                        <Calendar
                            selected={sampleCollectionState.sampleCollectionUpdateRequest.evaluationDate}
                            onChange={(date) => dispatch(setSCUpdateEvaluationDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCUpdateEvaluationDate(date))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Utente Valutazione
                    </div>
                    <div className="assignment-text-bold text-left">
                        {`${userState.findMeResponse.name} ${userState.findMeResponse.surname}`}
                    </div>
                </div>

                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Principi attivi riscontrati e valori
                    </div>
                    <TextArea
                        value={sampleCollectionState.sampleCollectionUpdateRequest.principlesFound}
                        onChangeText={(text) => dispatch(setSCUpdatePrinciplesFound(text))}
                    />
                </div>

                <div className="pt-5 pb-5">
                    <div className="assignment-text-content text-left">
                        Note
                    </div>
                    <TextArea
                        value={sampleCollectionState.sampleCollectionUpdateRequest.note}
                        onChangeText={(text) => dispatch(setSCUpdateNote(text))}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(SampleCollectionUpdate({ body: sampleCollectionState.sampleCollectionUpdateRequest, id: sampleCollectionState.sampleCollectionIdToUpdate }))}
                    />
                </div>
            </div>
        </div>
    )
}